import React from 'react';
import { Layout } from 'antd';
import { GithubOutlined, XOutlined, LinkedinOutlined, FileTextOutlined, DiscordOutlined, MessageOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './Footer.scss';
import logo from './../assets/logo.svg';

const { Footer } = Layout;

const AppFooter: React.FC = () => {
  const socialLinks = [
    { key: 'docs', icon: <FileTextOutlined />, url: 'https://docs.replicats.ai/' },
    { key: 'x', icon: <XOutlined />, url: 'https://x.com/replicatsai' },
    { key: 'github', icon: <GithubOutlined />, url: 'https://github.com/replicatsai' },
    { key: 'telegram', icon: <MessageOutlined />, url: 'https://t.me/replicatsai' },
    { key: 'linkedin', icon: <LinkedinOutlined />, url: 'https://www.linkedin.com/company/replicats/posts/?feedView=all' },
    { key: 'discord', icon: <DiscordOutlined />, url: 'https://discord.com/invite/replicatsai' },
  ];

  const legalLinks = [
    { text: 'Terms', url: '/terms' },
    { text: 'Privacy Policy', url: '/privacy-policy' },
  ];

  const companyLinks = [
    { text: 'Contact', url: 'mailto:replicatssupport@zendesk.com' },
  ];

  return (
    <Footer className="app-footer">
      <div className="footer-content">
        <div className="footer-column footer-company">
          <a href="/" className="footer-logo">
            <img src={logo} alt="Replicats Logo" className="logo-image" />
          </a>
          <p className="footer-description">
            Replicats: Your First AI Investment Copilot.
          </p>
        </div>
        <div className="footer-column footer-links">
          <h4 className="footer-title">Company</h4>
          <ul className="footer-list">
            {companyLinks.map((link) => (
              <li key={link.text}>
                <Link to={link.url} className="footer-link">
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-column footer-legal">
          <h4 className="footer-title">Legal</h4>
          <ul className="footer-list">
            {legalLinks.map((link) => (
              <li key={link.text}>
                <Link to={link.url} className="footer-link">
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-column footer-social">
          <h4 className="footer-title">Follow Us</h4>
          <div className="social-icons">
            {socialLinks.map((link) => (
              <a
                key={link.key}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        © {new Date().getFullYear()} Replicats. All rights reserved.
      </div>
    </Footer>
  );
};

export default AppFooter;